import React, { useCallback, useEffect, useState } from "react";
import { ITop10Article } from "../../../types/Top10Article";
import { useParams } from "react-router-dom";
import { getTop10Articles } from "../../Top10Articles/action";
import { Card, message, Pagination, Spin } from "antd";
import { getCounter } from "../../../lib/functions";
import { getMainWebsiteByID, setMainWebsiteHomepage } from "../actions";
import { IMainWebsite } from "../../../types/MainWebsite";

type Props = {};

const Homepage = (props: Props) => {
  const { id } = useParams();
  const [mainWebsite, setMainWebsite] = useState<IMainWebsite | null>(null);
  const [data, setData] = useState<ITop10Article[]>([]);
  const [page, setPage] = useState(1); // <-- AntD Pagination is 1-based
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const fetchCount = useCallback(async () => {
    try {
      const count = await getCounter("Top10Articles");
      setTotal(count || 0);
    } catch (error) {
      message.error("Failed to fetch count");
    }
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const main_website = await getMainWebsiteByID(id!);
      if (main_website) setMainWebsite(main_website);
      const articles = await getTop10Articles(pageSize, page - 1, query);
      // 👆 your backend seems to expect 0-based page, so subtract 1
      setData(articles);
    } catch (error) {
      message.error("Failed to fetch articles");
    } finally {
      setLoading(false);
    }
  }, [id, page, pageSize, query]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  const setHomepage = async (homepage_id: string) => {
    const website = await setMainWebsiteHomepage(id!, homepage_id);
    if (website) {
      message.success("Homepage set successfully");
      setMainWebsite(website);
    }
  };

  return (
    <div className="space-y-6">
      <Spin spinning={loading}>
        <div className="grid grid-cols-3 gap-4">
          {data.map((dt) => (
            <Card
              key={dt.id}
              hoverable
              onClick={() => setHomepage(dt.id)}
              style={{
                border:
                  mainWebsite?.HomePage?.id === dt.id
                    ? "2px solid #1677ff"
                    : "",
              }}
            >
              <h2 className="text-lg font-bold">{dt.MainInfo.Title.En}</h2>
              <h3 className="text-xs">{dt.MainInfo.Title.Ar}</h3>
              <h3 className="text-xs">{dt.MainInfo.Title.Fr}</h3>
            </Card>
          ))}
        </div>
      </Spin>

      <div className="flex justify-end">
        <Pagination
          current={page}
          pageSize={pageSize}
          total={total}
          showSizeChanger
          onChange={(p, ps) => {
            setPage(p);
            setPageSize(ps);
          }}
        />
      </div>
    </div>
  );
};

export default Homepage;
